import React from 'react'
import './voiceSubheader.scss';

const VoiceSubheader = React.forwardRef(({ children }, ref) => {

  return (
    <div className="voice-subheader" ref={ref}>
      {children}
    </div>
  )
})

export default VoiceSubheader;